/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import AppDispatcher from '../dispatcher/AppDispatcher';
import AppConstants from '../constants/AppConstants';
import UserAPI from '../api/awsUserAPI';
import JobAPI from '../api/awsJobAPI';
import ProductAPI from '../api/awsProductAPI';


class APIActionsClass {

    makeHandler(successAction,failAction) {
        return {
            success : (r) => {
                console.log("[API-ACTION] " + successAction, r);
                if (r.statusCode && r.statusCode === 200) {
                    AppDispatcher.handleViewAction({
                        actionType  : successAction,
                        status      : 'OK',
                        result      : JSON.parse(r.body)
                    });
                }
                else if (r.statusCode && r.statusCode === 404) { // not found
                    AppDispatcher.handleViewAction({
                        actionType  : successAction,
                        status      : 'OK',
                        result      : r.body ? JSON.parse(r.body) : null
                    });
                }
                else {
                    AppDispatcher.handleViewAction({
                        actionType  : failAction,
                        status      : 'ERROR',
                        error       : r.body
                    });
                }
            },

            failure : (e) => {
                console.log("[API-ACTION] " + failAction, e);

                // typically comms errors
                AppDispatcher.handleViewAction({
                    actionType  : failAction,
                    status      : 'ERROR',
                    error       : e
                });
            }
        }
    }

    searchJobs(searchText, email) {
        console.log("[API] - searchJobs: ", searchText, email);
        JobAPI.searchJobs(searchText, email, APIActions.makeHandler(AppConstants.SEARCH_JOBS,AppConstants.SEARCH_JOBS_ERR));
    }

    saveJob(job) {
        console.log("[API] - saveJob: ", job);

        JobAPI.saveJob(job, APIActions.makeHandler(AppConstants.SAVE_JOB,AppConstants.SAVE_JOB_ERR));
    }

    jobHistory(jobnum) {
        console.log("[API] - job history: ", jobnum);
        JobAPI.getJobHistory(jobnum, APIActions.makeHandler(AppConstants.GET_JOB_HISTORY,AppConstants.GET_JOB_HISTORY_ERR));
    }

    jobHistoryDay(jobId,timestamp) {
        console.log("[API] - job history day: ", jobId, timestamp);
        JobAPI.getJobHistoryDay(jobId, timestamp, APIActions.makeHandler(AppConstants.GET_JOB_HISTORY_DAY,AppConstants.GET_JOB_HISTORY_ERR));
    }

    jobHistoryRange(jobId,fromtime,totime) {
        console.log("[API] - job history day: ", jobId, fromtime, totime);
        JobAPI.getJobHistoryRange(jobId, fromtime, totime, APIActions.makeHandler(AppConstants.GET_JOB_HISTORY_DAY,AppConstants.GET_JOB_HISTORY_ERR));
    }

    jobHistorySummary(jobId) {
        console.log("[API] - job history summary: ", jobId);
        JobAPI.getJobHistorySummary(jobId, APIActions.makeHandler(AppConstants.GET_JOB_HISTORY_SUMMARY,AppConstants.GET_JOB_HISTORY_ERR));
    }

    allUsers() {
        console.log("[API] - allUsers ");

        UserAPI.allUsers(APIActions.makeHandler(AppConstants.ALL_USERS,AppConstants.ALL_USERS_ERR));
    }

    userByEmail(email) {
        console.log("[API] - userByEmail: ", email);

       UserAPI.userByEmail(email,APIActions.makeHandler(AppConstants.USER_BY_EMAIL,AppConstants.USER_BY_EMAIL_ERR));
    }

    allDealerUsers(dealerId) {
        console.log("[API] - allDealerUsers: ", dealerId);

        UserAPI.allDealerUsers(dealerId,APIActions.makeHandler(AppConstants.ALL_DEALER_USERS,AppConstants.ALL_DEALER_USERS_ERR));
    }

    allDealers() {
        console.log("[API] - allDealers: ");

        UserAPI.allDealers(APIActions.makeHandler(AppConstants.ALL_DEALERS,AppConstants.ALL_DEALERS_ERR));
    }

    deleteDealer(dealer) {
        console.log("[API] - deleteDealer: ");
        UserAPI.deleteDealer(dealer,APIActions.makeHandler(AppConstants.DELETE_DEALER,AppConstants.DELETE_DEALER_ERR));
    }

    deleteJob(jobId) {
        console.log("[API] - deleteJob: ");
        JobAPI.deleteJob(jobId,APIActions.makeHandler(AppConstants.DELETE_JOB,AppConstants.DELETE_JOB_ERR));
    }

    loadJob(jobId) {
        console.log("[API] - loadJob: ");
        JobAPI.getJob(jobId,APIActions.makeHandler(AppConstants.LOAD_JOB,AppConstants.LOAD_JOB_ERR));
    }

    saveDealer(dealer) {
        console.log("[API] - saveDealer: ");

        UserAPI.saveDealer(dealer,APIActions.makeHandler(AppConstants.SAVE_DEALER,AppConstants.SAVE_DEALER_ERR));
    }

    saveUser(user) {
        console.log("[API] - saveUser: ");
        UserAPI.saveUser(user,APIActions.makeHandler(AppConstants.SAVE_USER,AppConstants.SAVE_USER_ERR));
    }

    getAllProducts() {
        console.log("[API] - getAllProducts: ");

        ProductAPI.getAllProducts(APIActions.makeHandler(AppConstants.PRODUCT_SET_LOAD,AppConstants.PRODUCT_SET_LOAD_ERR));
    }

    getProduct(productId) {
        console.log("[API] - getProduct: ");

       ProductAPI.getProduct(productId, APIActions.makeHandler(AppConstants.PRODUCT_LOAD,AppConstants.PRODUCT_LOAD_ERR));
    }

    saveProduct(product) {
        console.log("[API] - saveProduct: ");
        ProductAPI.saveProduct(product, APIActions.makeHandler(AppConstants.PRODUCT_SAVE, AppConstants.PRODUCT_SAVE_ERR));
    }

    attachImageToJob(jobId, imageContent) {
        JobAPI.attachImageToJob(jobId, imageContent, APIActions.makeHandler(AppConstants.JOB_IMAGE_SAVE, AppConstants.JOB_IMAGE_SAVE_ERR) )
    }
}

const APIActions = new APIActionsClass();
export default APIActions;



// WEBPACK FOOTER //
// ./src/app/actions/apiActions.js